// شرائح حجم الشركة حسب عدد الموظفين الفعلي.
export const SIZE_BUCKETS = [
  { id: "1-10", label: "1 – 10", min: 1, max: 10 },
  { id: "11-25", label: "11 – 25", min: 11, max: 25 },
  { id: "26-50", label: "26 – 50", min: 26, max: 50 },
  { id: "51-100", label: "51 – 100", min: 51, max: 100 },
  { id: "101-250", label: "101 – 250", min: 101, max: 250 },
  { id: "251+", label: "+250", min: 251, max: null },
];
